import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { Action } from '@atlassian/react-sweet-state';
import type { ContainerProps, InsightObjectViewState } from '../../../../common/types/index.tsx';
import { setHideEmptyAttributes } from '../../../../services/hide-empty-attributes/index.tsx';

export const setHideEmptyAttributesState =
	(hideEmptyAttributes: boolean): Action<InsightObjectViewState, ContainerProps> =>
	async ({ setState, getState }, { createAnalyticsEvent }) => {
		const { objectDetails } = getState();
		if (objectDetails != null) {
			setHideEmptyAttributes(hideEmptyAttributes, objectDetails.objectType.id);
		}
		fireTrackAnalytics(createAnalyticsEvent({}), 'hideEmptyCmdbObjectAttributes toggled', {
			shouldHide: hideEmptyAttributes,
		});
		setState({ hideEmptyAttributes });
	};
